module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+ODIxMzQxNkQtQjIzQy00NDYzLThCREQtMzExQkNFNzJENjk4PC90aXRsZT48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNMTkgNXYxNEg1VjVoMTR6bTAtMkg1Yy0xLjEgMC0yIC45LTIgMnYxNGMwIDEuMS45IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6IiBmaWxsLW9wYWNpdHk9Ii41MzkiIGZpbGw9IiMwMDAiIG9wYWNpdHk9Ii41NCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ../ui-components/components/Checkbox/off.svg
// module id = 2234
// module chunks = 1